<template>
  <transition>
    <div class="w-24 h-24 ">
      <svg
        class="spinner w-24 h-24"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 75 75"
      >
        <path
          d="M31.42,2.58c0,.25,0,.5,0,.73s.2.47.22.71.07.49.1.72-.07.5,0,.73.15.48.18.71.09.49.11.72.06.49.09.72.05.48.08.72,0,.48,0,.72,0,.48.05.72.22.45.26.7,0,.47,0,.72,0,.47,0,.73.17.45.2.7.07.47.1.72-.08.48-.05.73.16.47.18.72"
          
          style="fill: none"
        />
        <path
          d="M17.09,8.19c.15.21.34.38.47.57s.2.49.34.68l.43.61c.15.21.33.39.46.58s.25.45.39.64.27.43.41.62.37.34.51.54.29.39.44.59.21.45.36.66.33.35.48.56l.44.59c.14.19.27.4.42.61s.27.4.42.62.24.42.39.63"
          
          style="fill: none"
        />
        <path
          d="M5.51,19.76c.21.13.44.2.64.32l.61.35c.2.12.4.25.6.36s.44.19.64.3l.59.38c.22.12.45.17.65.28s.35.35.55.45l.63.32c.21.11.45.17.66.26s.4.26.61.34.42.21.64.29.48,0,.7.11l.68.19c.22.06.41.22.65.27s.46,0,.7.08l.69.11"
          
          style="fill: none"
        />
        <path
          d="M2.67,35.29c.24,0,.47-.09.7-.09s.48-.12.7-.12.49.15.71.15.48,0,.7,0,.49,0,.71,0,.48-.06.7-.06h1.4c.24,0,.47-.07.7-.06l.7,0c.22,0,.45-.08.7-.08s.45.15.7.14h.7c.22,0,.45-.07.7-.07s.46.06.7.06.47,0,.71,0"
          
          style="fill: none"
        />
        <path
          d="M5.35,50.86c.22-.1.48-.12.7-.22s.4-.28.62-.39.39-.29.61-.4.47-.12.69-.23.46-.15.68-.25.4-.28.61-.39.39-.3.61-.41.51-.06.72-.17.45-.18.66-.28.42-.24.63-.35.41-.27.62-.38l.64-.35.63-.33c.22-.12.4-.3.6-.42s.44-.22.64-.34.38-.33.56-.45.52-.16.67-.29.46-.45.44-.58"
          
          style="fill: none"
        />
        <path
          d="M23.62,51.5c-.13.21-.33.36-.45.56l-.38.59c-.13.21-.24.42-.36.61s-.23.42-.35.61-.23.42-.35.61-.33.36-.45.55-.19.45-.31.64-.18.45-.3.64-.33.35-.45.55-.3.35-.43.55-.18.43-.31.63-.16.44-.29.65-.38.29-.51.5-.28.37-.41.58-.22.4-.35.6-.2.42-.32.63l-.37.6-.38.6"
          
          style="fill: none"
        />
        <path
          d="M35.88,64c0-.25-.05-.48-.08-.71s-.13-.47-.16-.7,0-.48-.06-.7,0-.49,0-.71-.14-.48-.17-.7,0-.49,0-.71,0-.48-.05-.71-.07-.47-.09-.7-.08-.46-.1-.7-.08-.45-.11-.69,0-.47,0-.72-.13-.44-.16-.69-.14-.44-.17-.69,0-.47,0-.71,0-.47,0-.71-.13-.46-.16-.7"
          
          style="fill: none"
        />
        <path
          d="M44.89,50.57c.15.2.38.33.52.5s.31.38.45.56.27.41.42.58.27.41.41.59l.45.55c.16.2.34.35.49.53l.43.56c.15.18.28.38.43.57s.34.32.49.51.24.4.4.59.28.37.44.56l.45.55c.14.17.31.35.46.54s.31.35.47.55"
          
          style="fill: none"
        />
        <path
          d="M51.69,42.34c.23.1.49.12.7.21s.48.12.69.21.37.38.58.47.47.15.68.24.44.21.65.29.5.07.72.15l.66.26c.23.09.43.23.64.32s.42.24.64.33l.66.26c.21.09.46.11.69.2s.42.2.65.29.41.21.64.31.47.09.7.19.39.26.62.35l.66.29c.21.09.44.16.67.26"
          
          style="fill: none"
        />
        <path
          d="M52.79,31.7c.25,0,.49.06.73,0s.49-.08.72-.09.49-.09.71-.11.5-.07.72-.08.51.09.74.08.48-.12.71-.14.48-.1.72-.12.49.18.73.16.47-.07.71-.09.47,0,.72,0,.45-.17.71-.19.46-.05.71-.06.47,0,.73,0,.47,0,.72,0l.72,0c.23,0,.47-.1.72-.11"
          
          style="fill: none"
        />
        <path
          d="M50.87,23.37c.24-.1.51-.09.72-.19s.41-.29.62-.39.49-.15.7-.24.43-.26.64-.36l.65-.32c.24-.11.48-.15.69-.25s.43-.25.64-.35.41-.26.63-.36.41-.24.64-.35.47-.1.7-.21.39-.27.63-.38.4-.25.63-.36.5,0,.73-.14.42-.23.65-.34.44-.18.67-.29"
          
          style="fill: none"
        />
        <path
          d="M48.62,6.11c-.11.22-.17.46-.27.67s-.24.42-.34.62-.19.45-.29.65-.18.46-.27.66-.18.45-.28.65-.34.38-.43.59-.11.48-.21.68-.27.4-.37.61-.15.45-.25.66-.18.42-.29.64-.26.39-.37.61-.15.43-.26.66-.14.44-.25.66-.17.43-.27.65-.31.36-.42.58-.14.45-.25.68-.15.44-.26.67"
          
          style="fill: none"
        />
      </svg>
    </div>
  </transition>
</template>

<script>
export default {};
</script>

<style>
.spinner path {
  fill: none;
  stroke: #19324F !important;
  stroke-width: 4;
  stroke-linecap: round;
}

svg.spinner{
  animation-name: spin;
  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear; 
}

@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}

</style>
